import { Component } from '@angular/core';

@Component({
  selector: 'am-hotels-list-skeleton',
  styleUrls: ['./hotels-list-skeleton.component.scss'],
  templateUrl: './hotels-list-skeleton.component.html',
})
export class HotelsListSkeletonComponent {
  constructor() {}
}
